import React, { Component } from 'react'
import Quagga from 'quagga'
import { Header, Modal, FlexWrapper, XLMText, Button } from '../components'
import styled from 'styled-components'
import Cookies from 'js-cookie'
const ScannerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 0 auto;
  width: ${props => (props.width ? props.width : '320')}px;
  & > * {
    width: ${props => (props.width ? props.width : '320')}px;
  }
  & video {
    width: ${props => (props.width ? props.width : '320')}px;
  }
  & canvas {
    display: none;
    width: ${props => (props.width ? props.width : '320')}px;
  }
`

class ProductScanning extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showModal: false,
      width: 0,
      height: 0,
      result: null,
      productName: [],
      upcDetected: 0
    }
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this)
    this._onDetected = this._onDetected.bind(this)
  }
  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight })
  }

  componentDidMount() {
    this.updateWindowDimensions()
    window.addEventListener('resize', this.updateWindowDimensions)
    Quagga.init(
      {
        inputStream: {
          target: document.getElementById('interactive'),
          type: 'LiveStream',
          constraints: {
            width: 640,
            height: 480,
            facingMode: 'environment' // or user
          },
          area: {
            // defines rectangle of the detection/localization area
            top: '0%', // top offset
            right: '0%', // right offset
            left: '0%', // left offset
            bottom: '0%' // bottom offset
          }
        },

        locator: {
          patchSize: 'medium',
          halfSample: true
        },
        locate: true,
        multiple: false,
        numOfWorkers: 4,
        decoder: {
          readers: ['code_128_reader', 'upc_reader', 'upc_e_reader']
        }
      },
      function(err) {
        if (err) {
          return console.log(err)
        }
        Quagga.start()
      }
    )
    Quagga.onDetected(this._onDetected)
  }

  componentWillUnmount() {
    Quagga.offDetected(this._onDetected)
    this.setState({ upcDetected: 0 })
    window.removeEventListener('resize', this.updateWindowDimensions)
  }

  async _onDetected(result) {
    // await delay(3000)
    if (this.state.upcDetected === 0) {
      this.setState({ showModal: true })
    } else if (this.state.upcDetected === 1) {
      this.setState({ showModal: true })
    } else if (this.state.upcDetected === 2) {
      this.props.history.push({
        pathname: '/products'
        // code: get(result, 'codeResult.code', '')
      })
    }
    /*  this.setState({ upcDetected: 1 })
    if (this.state.upcDetected === 1) {
      this.setState({ showModal: true })
    /* } else if (this.state.upcDetected === 2) {
      this.setState({ showModal: true })
    } else {
    }  */
    // console.log('result', result)

    // this.setState({ result })
    // Quagga.offDetected(this._onDetected)
    /* try {
      const { data } = await axios.get(`${API_URL}/ProductTables`, {
        filter: {
          limit: 1,
          where: {
            productCode: {
              like: get(result, 'codeResult.code', '')
            }
          }
        }
      })

      console.log('DATA', data)

      this.setState({ productName: data })
    } catch (error) {
      console.log('ERROR', error)
    } */
  }

  render() {
    const { showModal, upcDetected } = this.state
    return (
      <React.Fragment>
        <Header
          title="Barcode Scanner"
          showProfile
          icon={'arrowBack'}
          onClickProfile={() => this.props.history.push('/user-profile')}
          onClickBack={() =>
            Cookies.get('prevPath') ? this.props.history.replace(Cookies.get('prevPath')) : this.props.history.goBack()
          }
          color="#fff"
        />
        {/* <PageWrapper viewPadding="10px 16px 20px"> */}
        <ScannerWrapper width={this.state.width}>
          <div id="interactive" className="viewport" />
        </ScannerWrapper>
        {/* <pre>{get(result, 'codeResult.code', '----')}</pre> */}
        {/* </PageWrapper> */}

        <Modal
          show={showModal}
          title={upcDetected === 1 ? 'Thanks for the feedback!' : upcDetected === 0 ? 'SORRY!' : ''}>
          <FlexWrapper alignItems="center">
            <XLMText fontWeight={600}>
              {upcDetected === 1
                ? ''
                : upcDetected === 0
                ? 'We are sorry the barcode scanner is not connected at this time. If you want a barcode scanner available,you can let us know by simply scanning the same barcode again!'
                : ''}
            </XLMText>
            <Button
              label="Okay"
              namespace="Barcode Scanner"
              margin="0 10px"
              size="small"
              onClick={() => this.setState({ upcDetected: this.state.upcDetected === 1 ? 2 : 1, showModal: false })}
            />
          </FlexWrapper>
        </Modal>
      </React.Fragment>
    )
  }
}

export default ProductScanning



// WEBPACK FOOTER //
// ./src/pages/ProductScanning.js